import React from 'react';
import { COURSE_DETAIL_TRANSLATION_KEY } from 'Jsx/Utils/transformKeys';
import { useTranslation } from 'Shared/Hooks/useTranslation';

import Text from 'crehana-ui/Text';

const AboutSection = ({ course }) => {
  const { t } = useTranslation(COURSE_DETAIL_TRANSLATION_KEY);

  return (
    <section className="mb-40 sm:mb-48">
      <Text className="mb-16 sm:mb-24" type="h4" as="h2">
        {t('ABOUT_TITLE')}
      </Text>
      {course.about?.length > 0 && (
        <Text type="body2" as="p">
          {course.about}
        </Text>
      )}
    </section>
  );
};

export default AboutSection;
